import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloakClient from './Keycloak';
import { apiService } from './ExternalApiService';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
const initOptions = {
  onLoad: 'check-sso', // uses the silent-check iframe
  pkceMethod: 'S256',
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
};

const extractTenantDomain = (kc) => {
  const tenant = kc?.tokenParsed || {};
  return (
    tenant.domain ||
    null
  );
};

const onTokens = () => {
  apiService.setKeycloakClient(keycloakClient);
  const domain = extractTenantDomain(keycloakClient) || 'no-domain'
  apiService.setTenant(domain)
};

const onEvent = (event, error) => {
  if (event === 'onAuthSuccess' || event === 'onAuthRefreshSuccess' || event === 'onTokens') {
    const domain = extractTenantDomain(keycloakClient) || 'no-domain'
    apiService.setTenant(domain);
  }
};

root.render(
  // <StrictMode>
  <>
    <ColorModeScript />
    <ReactKeycloakProvider 
     authClient={keycloakClient}
      initOptions={initOptions}
      onTokens={onTokens}
      onEvent={onEvent}
    >
      <App />
    </ReactKeycloakProvider>
  </>
  // </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
